import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import { APIRoutes } from "../../../utility/app-routes";
import { MasterCommonRecordPage } from "../../../components/common/common-master-record/master-common-record-page";

const NonUse: React.FC = () => {
	// Table Pagination

	return (
		<div className="page-inner">
			<>
				<MasterCommonRecordPage
					addUpdateApiUrl={APIRoutes.appUpdateNonUse}
					deleteApiUrl={APIRoutes.deleteNonUse}
					title="NonUse"
					getAllRecordApiUrl={APIRoutes.getAllNonUse}
				/>
			</>
		</div>
	);
};
export default NonUse;
